<template>
    <div class="AdminPanel">
      <UserHeaderMenu/>
        <div class="container mt-3">
          <h4 class="pb-2"><b>Céges beállítások</b></h4>
          <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <b-form-group
                      class="mb-0"
                      label="Cég neve"
                    >
                      <b-form-input
                        v-model="companyData.name"
                        placeholder="Például: Valami kft"
                        @keyup="changeCompanyName"
                      ></b-form-input>
                    </b-form-group>
                    </div>
                    <div class="col-lg-4">
                    <b-form-group
                      class="mb-0"
                      label="Cég logó (ajánlott méret: 200x100 px)"
                    >
                     <b-form-file
                     class="mt-0"
                     type="file"
                     value="asd"
                      browse-text="Keresés"
                      v-model="logo"
                      accept=".jpg, .png, .svg"
                      placeholder="Logó cseréhez tölts fel újat"
                    >
                    </b-form-file>
                    <b-button @click="changeLogo" class="mt-2" :style="{'background':companyData.color, 'border':'none'}" size="sm">Kép cserélése</b-button>
                    <b-button v-b-modal.modal-img-2 class="mt-2 ml-2" :style="{'background':companyData.color, 'border':'none'}" size="sm">Kép megtekintkés</b-button>
                    <div>
                      <b-modal id="modal-img-2" hide-footer hide-header ok-only ok-title="Bezár" header-close>
                        <img :style="{'width' : '100%'}" :src="'https://creativesales.hu/munkalatok/vueapi/uploads/'+companyData.logo_src">
                      </b-modal>
                    </div>
                    </b-form-group>
                    </div>
                    <div class="col-lg-4">
                    <b-form-group class="mb-0" label="Cég színe">
                    <v-swatches v-model="companyData.color" :value="companyData.color" show-fallback fallback-input-type="color" @input="changeColor" popover-x="left"></v-swatches>
                    </b-form-group>
                    </div>
                    <div class="col-lg-4">
                    <b-form-group
                      class="mb-0"
                      label="Cég pdf banner (ajánlott méret: 595x100 px)"
                    >
                     <b-form-file
                      browse-text="Keresés"
                      v-model="header"
                      value=""
                      type="file"
                      accept=".jpg, .png, .svg"
                      placeholder="Banner cseréhez tölts fel újat"
                    >
                    </b-form-file>
                    <b-button @click="changeHeader" class="mt-2" :style="{'background':companyData.color, 'border':'none'}" size="sm">Kép cserélése</b-button>
                    <b-button v-b-modal.modal-img-1 class="mt-2 ml-2" :style="{'background':companyData.color, 'border':'none'}" size="sm">Kép megtekintkés</b-button>
                    <div>
                      <b-modal id="modal-img-1" hide-footer hide-header ok-only ok-title="Bezár" header-close>
                        <img :style="{'width' : '100%'}" :src="'https://creativesales.hu/munkalatok/vueapi/uploads/'+companyData.pdf_header">
                      </b-modal>
                    </div>
                    </b-form-group>
                    </div>
                    <div class="col-lg-4">
                    <b-form-group
                      class="mb-0 mt-3"
                      label="Székhely"
                    >
                      <b-form-input
                        v-model="companyData.szekhely"
                        placeholder="pl.: 4028 Debrecen Kassai út 129"
                        @keyup="changeLocation"
                      ></b-form-input>
                    </b-form-group>
                    </div>
                    <div class="col-lg-4">
                    <b-form-group
                      class="mb-0 mt-3"
                      label="IBAN"
                    >
                      <b-form-input
                        v-model="companyData.bank"
                        placeholder="pl.: OTP 0000000-0000000-000000000000"
                        @keyup="changeBank"
                      ></b-form-input>
                    </b-form-group>
                    </div>
                    <div class="col-lg-4">
                    <b-form-group
                      class="mb-0 mt-3"
                      label="Számlaszám"
                    >
                      <b-form-input
                        v-model="companyData.szamlaszam"
                        placeholder="pl.: 172-0000000-00000000"
                        @keyup="changeTaxnumber"
                      ></b-form-input>
                    </b-form-group>
                    </div>
                    <div class="col-lg-4">
                    <b-form-group
                      class="mb-0 mt-3"
                      label="Adószám"
                    >
                      <b-form-input
                        v-model="companyData.adoszam"
                        placeholder="pl.: 1-23-45678"
                        @keyup="changeAdoszam"
                      ></b-form-input>
                    </b-form-group>
                    </div>
                </div>
              </div>
          </div>
        </div>
        <SettingsModal/>
    </div>
</template>
<script>
import VSwatches from 'vue-swatches'
import router from "../router"
import axios from 'axios'
import SettingsModal from '../components/SettingsModal.vue'
import UserHeaderMenu from '../components/UserHeaderMenu.vue'
import "vue-swatches/dist/vue-swatches.css"

export default {
  components: {
    SettingsModal,
    UserHeaderMenu,
    VSwatches 
  },
  name: 'AdminPanel',
  mounted(){
    this.getCompanyData()
  },
  data() {
      return {
        logo: [],
        header: [],
        color: '',
        suckerCanvas: null,
        suckerArea: [],
        isSucking: false,
        quotesTypes:[

        ],
        items: [
          
        ],
        companyData:[

        ],
      }
    },
    computed: {
      rows() {
        return this.items.length
      }
    },
    methods:{
        changeAdoszam(){
            const params = new URLSearchParams();
            params.append('updateCompanyAdoszam', true);
            params.append('companyAdoszam', this.companyData.adoszam);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then(() => {
              
            })          
        },
        changeTaxnumber(){
            const params = new URLSearchParams();
            params.append('updateCompanySzamlaszam', true);
            params.append('companySzamlaszam', this.companyData.szamlaszam);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then(() => {
              
            })          
        },
        changeBank(){
            const params = new URLSearchParams();
            params.append('updateCompanyBank', true);
            params.append('companyBank', this.companyData.bank);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then(() => {
              
            })          
        },
        changeLocation(){
            const params = new URLSearchParams();
            params.append('updateCompanySzekhely', true);
            params.append('companySzekhely', this.companyData.szekhely);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then(() => {
              
            })          
        },
        changeCompanyName(){
            const params = new URLSearchParams();
            params.append('updateCompanyName', true);
            params.append('companyName', this.companyData.name);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then(() => {
              
            })
        },
        changeLogo(){
            let formData = new FormData();
            formData.append('logo', this.logo);
            formData.append('user_id', this.$session.get('id'));
            axios.post(process.env.VUE_APP_ADMIN_API,
              formData,
              {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }).then((response) => {
                this.$children['0'].updateLogo()
                this.companyData.logo_src=this.companyData.logo_src+'?'+new Date().getTime();
                this.$swal('Logó sikeresen frissíve', '' ,'success')
                console.log(response);
            })
        },
        changeHeader(){
            let formData = new FormData();
            formData.append('header_logo', this.header);
            formData.append('user_id', this.$session.get('id'));
            axios.post(process.env.VUE_APP_ADMIN_API,
              formData,
              {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                this.companyData.pdf_header=this.companyData.pdf_header+'?'+new Date().getTime();
                this.$swal('Header sikeresen frissíve', 'Most már pdf nyomtatáskor a friss logó fog szerepelni' ,'success')
                console.log(response);
            })
        },
        changeColor() {
          const params = new URLSearchParams();
            params.append('updateCompanyColor', true);
            params.append('companyColor', this.companyData.color);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then((response) => {
                this.companyData = response.data[0]
            })
        },
        getCompanyData(){
            const params = new URLSearchParams();
            params.append('getCompanyData', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_LOGIN_API,
                data:params
            }).then((response) => {
                this.companyData = response.data[0]
                console.log(response);
            })
        },
        expandAdditionalInfo(row) {
            router.push({ path: `/quotesinfo/${row.sorszam}` })

        },
        loadTypes(){
          let params = new URLSearchParams();
          params = new URLSearchParams();
          params.append('getAllQuotesTypes', true);
          params.append('user_id', this.$session.get('id'));
          axios({
            method: 'post',
            url: process.env.VUE_APP_QUOTES_API,
            data:params
          }).then((response) => {
            this.quotesTypes = response.data
          })
        },
        loadTable(){
          let params = new URLSearchParams();
          params.append('getAllQuotes', true);
          params.append('QuotesStatus', this.QuotesStatus);
          params.append('QuotesClientName', this.QuotesClientName);
          params.append('QuotesClientContactName', this.QuotesClientContactName);
          params.append('QuotesNumber', this.QuotesNumber);
          params.append('QuotesCreateDate', this.QuotesCreateDate);
          params.append('QuotesCreaterName', this.QuotesCreaterName);
          params.append('QuotesCreaterPhoneNumber', this.QuotesCreaterPhoneNumber);
          params.append('selectedQuotesType', this.selectedQuotesType);
          params.append('user_id', this.$session.get('id'));
          axios({
            method: 'post',
            url: process.env.VUE_APP_QUOTES_API,
            data:params
          }).then((response) => {
            this.items = response.data
          })
        }
    }
}
</script>
<style>
.bg-light-gray{
    background:#e5e5e5;
}
.color-modal{
  width:204px;
}
#color-modal___BV_modal_content_>.modal-body{
  padding:0px;
  display: block;
  margin:0 auto;
}
#color-modal___BV_modal_header_{
  display:none;
}
#color-modal___BV_modal_footer_{
  border: none;
  display:block;
  text-align: center;
}
#color-modal___BV_modal_content_{
  padding:0px;
  margin:0px;
  width:100%;
  background:none;
  border:none;
}
#color-modal___BV_modal_footer_ > button.btn.btn-primary{
  color:black;
  background:none;
  border:1px solid black;
  font-size:10pt;
}
</style>
